import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=229975bc&scoped=true&"
import script from "./Banner.vue?vue&type=script&lang=js&"
export * from "./Banner.vue?vue&type=script&lang=js&"
import style0 from "./Banner.vue?vue&type=style&index=0&id=229975bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229975bc",
  null
  
)

export default component.exports